import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-scroll';
import React from 'react';

const SectionHeader = ({ text, id }: { text: string; id?: string }) => {
	return (
		<div className="px-4 sm:px-12 md:px-16  my-8 sm:my-10 md:text-center">
			<h1
				id={id}
				className=" text-2xl md:text-3xl font-bold text-primary"
			>
				{text}
			</h1>
			<Breadcrumbs
				aria-label="breadcrumb"
				className="flex justify-center items-center py-2"
			>
				<Link
					to="home"
					activeClass="active"
					spy={true}
					smooth={true}
					offset={-50}
					duration={500}
					className="hover:underline underline-offset-2 hover:text-blue-400"
				>
					Home
				</Link>
				<Typography className="text-slate-400">{text}</Typography>
			</Breadcrumbs>
		</div>
	);
};

export default SectionHeader;
